import { EventEmitter } from 'events';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers } from 'recompose';
import { ChurnZeroService, CLOCK_IN, CLOCK_OUT } from '../../../../modules/infra/observability/churnzero';
import withToggle from '../../../common/hoc/withToggle';
import { timeTrackingBarberToggle } from '../actions';
import {
  extendedHourlyWagesEnabled,
  getBarberActive,
  getBarberActiveRole,
  getBarberClockedTime,
  requirePasscodeEnabled,
} from '../selectors';

const mapStateToProps = (state, ownProps) => ({
  barberId: ownProps.barberId,
  clockedTime: getBarberClockedTime(state, ownProps.barberId),
  active: getBarberActive(state, ownProps.barberId),
  barberRole: getBarberActiveRole(state, ownProps.barberId),
  requirePasscode: requirePasscodeEnabled(state),
  extendedHourlyWages: extendedHourlyWagesEnabled(state),
});

const mapDispatchToProps = {
  timeTrackingBarberToggle,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withToggle('busy'),
  withHandlers({
    onTimeTrackToggle: props => (data) => {
      props.busyOn();

      ChurnZeroService.track(props.active ? CLOCK_OUT : CLOCK_IN);

      props.timeTrackingBarberToggle(props.barberId, data)
        .then(props.busyOff)
        .catch(props.busyOff);
    },
    toggleBusy: props => (data) => {
      if (props.barberId === data.barberId) {
        if (data.busy) {
          props.busyOn();

          return;
        }

        props.busyOff();
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      EventEmitter.prototype.on('extended-clock-in-busy', this.props.toggleBusy);
    },
    componentWillUnmount() {
      EventEmitter.prototype.removeListener('extended-clock-in-busy', this.props.toggleBusy);
    },
  }),
  withHandlers({
    onTrackClick: props => () => {
      if (!props.extendedHourlyWages) {
        props.onTimeTrackToggle();

        return;
      }

      EventEmitter.prototype.emit('open-extended-clock-in-modal', props.barberId);
    },
  })
);
